module.exports = __webpack_public_path__ + "static/media/book-open.52ac7d6a.svg";